/* DPetals Bloom theme JS — cart drawer (Section Rendering API), quick view,
   predictive search, carousels, sticky ATC, variant picker. */
(function () {
  'use strict';
  const qs = (s, c) => (c || document).querySelector(s);
  const qsa = (s, c) => Array.from((c || document).querySelectorAll(s));
  const R = window.theme.routes;

  /* ---------- money ---------- */
  function money(cents) {
    const amt = (cents / 100);
    /* same format as Liquid's money filter (₹299.00), so a price doesn't change look after a variant switch */
    const s = amt.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (window.theme.moneyFormat || '₹{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '');
  }

  /* ---------- price: one variant's price, MRP and % off (rounded down, like the Liquid snippet) ---------- */
  function pctOff(price, cmp) { return cmp > price ? Math.floor((cmp - price) * 100 / cmp) : 0; }
  function priceCfg(el) {
    const d = (el && el.dataset) || {};
    return { mrpLabel: d.mrpLabel != null ? d.mrpLabel : 'MRP', showMrp: d.showMrp !== 'false', showPct: d.showPct !== 'false' };
  }
  function priceInner(price, cmp, cfg, nowStyle) {
    cfg = cfg || priceCfg(null);
    let h = '<span class="now"' + (nowStyle ? ' style="' + nowStyle + '"' : '') + '>' + money(price) + '</span>';
    if (cfg.showMrp && cmp > price) {
      h += '<span class="mrp">' + (cfg.mrpLabel ? cfg.mrpLabel + ' ' : '') + money(cmp) + '</span>';
      if (cfg.showPct) h += '<span class="pct">' + pctOff(price, cmp) + '% off</span>';
    }
    return h;
  }

  /* ---------- toast ---------- */
  let toastT;
  function toast(msg) {
    const t = qs('#toast'); if (!t) return;
    t.textContent = '✓ ' + msg; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 2200);
  }

  /* ---------- overlays ---------- */
  function openEl(id) { closeAll(); const el = qs(id); if (el) el.classList.add('open'); qs('#ovl').classList.add('open'); }
  function closeAll() { ['#cart-drawer', '#qvmodal', '#searchov', '#ovl', '#mnav'].forEach(s => { const el = qs(s); if (el) el.classList.remove('open'); }); }
  window.dpCloseAll = closeAll;

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-close]')) { e.preventDefault(); closeAll(); return; }
    if (t.closest('#ovl')) { closeAll(); return; }
    if (t.closest('[data-open-mnav]')) { e.preventDefault(); openEl('#mnav'); return; }
    if (t.closest('[data-open-cart]')) { e.preventDefault(); openEl('#cart-drawer'); return; }
    if (t.closest('[data-open-search]')) { e.preventDefault(); openEl('#searchov'); const i = qs('#sq'); if (i) setTimeout(() => i.focus(), 60); return; }
    const qv = t.closest('[data-quick-view]');
    if (qv) { e.preventDefault(); e.stopPropagation(); quickView(qv.dataset.quickView); return; }
    const atc = t.closest('[data-add-to-cart]');
    if (atc) { e.preventDefault(); addToCart(atc.dataset.variantId, 1, atc); return; }
    const qc = t.closest('[data-qty-change]');
    if (qc) { e.preventDefault(); changeQty(qc.dataset.line, qc.dataset.qty); return; }
    const pq = t.closest('[data-pdp-qty]');
    if (pq) { pdpQty(parseInt(pq.dataset.pdpQty, 10)); return; }
    const pa = t.closest('[data-pdp-add]');
    if (pa) { e.preventDefault(); const id = qs('#variant-id').value; addToCart(id, pdpQ, pa); return; }
    const dot = t.closest('[data-hero-dot]');
    if (dot) { heroGo(parseInt(dot.dataset.heroDot, 10)); heroStart(); return; }
    if (t.closest('[data-hero-prev]')) { heroGo(heroI - 1); heroStart(); return; }
    if (t.closest('[data-hero-next]')) { heroGo(heroI + 1); heroStart(); return; }
    const mb = t.closest('[data-mega]');
    if (mb) { e.stopPropagation(); const m = qs('#' + mb.dataset.mega); if (m) m.classList.toggle('open'); return; }
    if (!t.closest('.mega')) qsa('.mega.open').forEach(m => m.classList.remove('open'));
  });
  qsa('[data-mega]').forEach(b => {
    const m = qs('#' + b.dataset.mega); if (!m) return;
    b.parentElement.addEventListener('mouseenter', () => m.classList.add('open'));
    b.parentElement.addEventListener('mouseleave', () => m.classList.remove('open'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
    if (e.key === '/' && !['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName)) { e.preventDefault(); openEl('#searchov'); const i = qs('#sq'); if (i) setTimeout(() => i.focus(), 60); }
  });

  /* ---------- cart (Section Rendering API) ---------- */
  async function refreshCartDrawer(open) {
    try {
      const [secRes, cartRes] = await Promise.all([fetch('/?sections=cart-drawer'), fetch('/cart.js')]);
      const sections = await secRes.json();
      const cart = await cartRes.json();
      const holder = document.createElement('div');
      holder.innerHTML = sections['cart-drawer'];
      const fresh = holder.querySelector('#cart-drawer');
      const current = qs('#cart-drawer');
      if (fresh && current) { const wasOpen = current.classList.contains('open') || open; current.replaceWith(fresh); if (wasOpen) { fresh.classList.add('open'); qs('#ovl').classList.add('open'); } msAnim(fresh); cpnUI(fresh); }
      const n = qs('#cartn');
      if (n) { n.textContent = cart.item_count; n.style.display = cart.item_count ? 'grid' : 'none'; }
    } catch (err) { console.error(err); }
  }
  function msAnim(scope) {
    const f = (scope || document).querySelector('.msfill');
    if (!f) { try { sessionStorage.setItem('dpMsPct', '0'); sessionStorage.setItem('dpMsTier', '0'); } catch (e) {} return; }
    const target = parseInt(f.dataset.pct || '0', 10);
    const tier = parseInt(f.dataset.tier || '0', 10);
    let prevP = 0, prevT = 0;
    try { prevP = parseInt(sessionStorage.getItem('dpMsPct') || '0', 10); prevT = parseInt(sessionStorage.getItem('dpMsTier') || '0', 10); } catch (e) {}
    f.style.width = prevP + '%';
    void f.offsetWidth;
    setTimeout(function () { f.style.width = target + '%'; }, 40);
    if (tier <= prevT) { const box = f.closest('.msbox'); if (box) box.classList.add('noanim'); }
    try { sessionStorage.setItem('dpMsPct', String(target)); sessionStorage.setItem('dpMsTier', String(tier)); } catch (e) {}
  }
  function cpnUI(scope) {
    let code = '';
    try { code = localStorage.getItem('dpCoupon') || ''; } catch (e) {}
    qsa('[data-coupon-box]').forEach(function (bx) {
      const msg = bx.querySelector('[data-coupon-msg]');
      if (msg) msg.innerHTML = code ? '✓ <b>' + code + '</b> will be applied at checkout <button type="button" class="cpnclear" data-coupon-clear aria-label="Remove coupon">✕ remove</button>' : '';
      bx.querySelectorAll('[data-coupon-apply-code]').forEach(function (b) { b.textContent = (b.dataset.couponApplyCode === code) ? 'Applied ✓' : 'Apply'; });
    });
  }
  async function applyCoupon(code) {
    if (!code) return;
    try { await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); } catch (e) {}
    try { localStorage.setItem('dpCoupon', code); } catch (e) {}
    cpnUI(document);
    toast('Coupon ' + code + ' will be applied at checkout');
  }
  document.addEventListener('click', function (e) {
    const ac = e.target.closest('[data-coupon-apply-code]');
    if (ac) { applyCoupon(ac.dataset.couponApplyCode); return; }
    const ap = e.target.closest('[data-coupon-apply]');
    if (ap) { const bx = ap.closest('[data-coupon-box]'); const i = bx && bx.querySelector('[data-coupon-input]'); if (i) applyCoupon((i.value || '').trim().toUpperCase()); return; }
    const cl = e.target.closest('[data-coupon-clear]');
    if (cl) { try { localStorage.removeItem('dpCoupon'); } catch (e2) {} document.cookie = 'discount_code=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT'; cpnUI(document); return; }
  });
  msAnim(document);
  cpnUI(document);
  async function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    if (btn) { btn.disabled = true; btn.dataset.oldText = btn.textContent; btn.textContent = '…'; }
    try {
      const res = await fetch(R.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
      });
      if (!res.ok) { const j = await res.json(); throw new Error(j.description || 'Could not add'); }
      toast(window.theme.strings.added);
      await refreshCartDrawer(true);
    } catch (err) { toast(err.message); }
    if (btn) { btn.disabled = false; btn.textContent = btn.dataset.oldText; }
  }
  async function changeQty(line, qty) {
    await fetch(R.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
    });
    if (qs('#cart-drawer.open')) { await refreshCartDrawer(true); } else { location.reload(); }
  }

  /* ---------- quick view ---------- */
  async function quickView(handle) {
    try {
      const res = await fetch('/products/' + handle + '.js');
      const p = await res.json();
      const v = p.variants.find(x => x.available) || p.variants[0];
      const img = p.images && p.images.length ? p.images[0] : null;
      const vlabel = p.variants.length > 1 ? '<div style="font-size:13px;color:var(--muted);margin-top:-4px">' + (v.public_title || v.title) + '</div>' : '';
      qs('#qvbody').innerHTML =
        '<div class="qvgrid"><div class="qi">' + (img ? '<img src="' + img + (img.indexOf('?')>-1?'&':'?') + 'width=900" alt="">' : '') + '</div>' +
        '<div class="qt"><h2>' + p.title + '</h2>' +
        '<p style="color:var(--muted);font-size:14px">' + (p.description || '').replace(/<[^>]+>/g, ' ').slice(0, 160) + '…</p>' +
        '<div class="price">' + priceInner(v.price, v.compare_at_price || 0, null, 'font-size:26px') + '</div>' + vlabel +
        '<div style="display:flex;gap:12px;margin-top:10px;flex-wrap:wrap">' +
        (v.available ? '<button class="btn p" style="flex:1" data-add-to-cart data-variant-id="' + v.id + '">Add to Cart</button>' : '<button class="btn p" disabled style="flex:1">Sold out</button>') +
        '<a class="btn o" href="' + p.url + '">Full Details</a></div>' +
        '<div style="font-size:12.5px;color:var(--muted);margin-top:8px">✓ Free delivery over ₹500 · ✓ COD available · ✓ Easy returns</div></div></div>';
      openEl('#qvmodal');
    } catch (err) { window.location.href = '/products/' + handle; }
  }

  /* ---------- predictive search ---------- */
  let searchT;
  const sq = qs('#sq');
  if (sq) sq.addEventListener('input', () => { clearTimeout(searchT); searchT = setTimeout(doSearch, 220); });
  qsa('#schips .chip').forEach(c => c.addEventListener('click', () => { sq.value = c.dataset.term || c.textContent.trim(); doSearch(); }));
  function searchPrice(p) {
    const c = (x) => Math.round(parseFloat(x || '0') * 100);
    const pr = c(p.price), cmin = c(p.compare_at_price_min), cmax = c(p.compare_at_price_max);
    const varies = c(p.price_min) !== c(p.price_max);
    /* if sizes differ in price and MRP, we can't tell which MRP goes with the lowest price — show the price only */
    const cmp = (cmin === cmax) ? cmax : 0;
    return (varies ? '<span class="from" style="font-size:12px;color:var(--muted)">From</span>' : '') + priceInner(pr, cmp, { mrpLabel: '', showMrp: true, showPct: false });
  }
  async function doSearch() {
    const q = (sq.value || '').trim();
    const out = qs('#sresults'), count = qs('#scount');
    if (!q) { out.innerHTML = ''; count.textContent = ''; return; }
    try {
      const res = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last');
      const data = await res.json();
      const items = data.resources.results.products || [];
      count.textContent = items.length + ' product' + (items.length === 1 ? '' : 's') + ' for “' + q + '”';
      out.innerHTML = items.map(p =>
        '<article class="pcard"><a class="pimg" href="' + p.url + '">' + (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?')>-1?'&':'?') + 'width=480" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="pbody"><h3 class="ptitle"><a href="' + p.url + '">' + p.title + '</a></h3>' +
        '<div class="price">' + searchPrice(p) + '</div></div></article>'
      ).join('') || '<p style="grid-column:1/-1;color:var(--muted)">No products found — try “aloe”, “hair fall”, “oil”…</p>';
      out.innerHTML += '<div style="grid-column:1/-1;text-align:center;padding:10px"><a class="btn o" href="' + R.search + '?q=' + encodeURIComponent(q) + '&type=product">See all results</a></div>';
    } catch (err) { /* noop */ }
  }

  /* ---------- hero carousel ---------- */
  let heroI = 0, heroTimer = null;
  function heroGo(i) {
    const slides = qsa('.hcar[data-hero-carousel] .hslide'); if (!slides.length) return;
    heroI = (i + slides.length) % slides.length;
    slides.forEach((s, x) => s.classList.toggle('on', x === heroI));
    qsa('[data-hero-dot]').forEach((d, x) => d.classList.toggle('on', x === heroI));
  }
  function heroStart() {
    clearInterval(heroTimer);
    if (qsa('.hcar[data-hero-carousel] .hslide').length > 1) heroTimer = setInterval(() => heroGo(heroI + 1), 5500);
  }
  heroStart();

  /* ---------- auto carousels (shop by concern) ---------- */
  qsa('[data-auto-carousel]').forEach(el => {
    const speed = parseInt(el.dataset.autoCarousel, 10) || 3000;
    let timer = setInterval(() => {
      if (el.scrollWidth <= el.clientWidth + 8) return;
      const step = el.children[0].getBoundingClientRect().width + 10;
      const max = el.scrollWidth - el.clientWidth;
      const next = el.scrollLeft + step > max - 8 ? 0 : el.scrollLeft + step;
      el.scrollTo({ left: next, behavior: 'smooth' });
    }, speed);
    el.addEventListener('pointerdown', () => clearInterval(timer));
  });

  /* ---------- PDP: gallery, qty, variants, sticky ---------- */
  let pdpQ = 1;
  function pdpQty(d) { pdpQ = Math.max(1, pdpQ + d); const el = qs('#pdpq'); if (el) el.textContent = pdpQ; const inp = qs('#pdp-qty-input'); if (inp) inp.value = pdpQ; }
  document.addEventListener('click', (e) => {
    const th = e.target.closest('[data-gal-thumb]');
    if (th) {
      const main = qs('#galmain');
      if (main) {
        if (th.dataset.mediaType === 'video' && th.dataset.videoSrc) {
          main.innerHTML = '<video id="galmainvid" controls playsinline poster="' + th.dataset.src + '"><source src="' + th.dataset.videoSrc + '" type="video/mp4"></video>';
        } else {
          main.innerHTML = '<img id="galmainimg" src="' + th.dataset.src + '" alt="">';
        }
      }
      qsa('[data-gal-thumb]').forEach(x => x.classList.remove('on')); th.classList.add('on');
    }
  });
  qsa('[data-variant-select]').forEach(sel => sel.addEventListener('change', () => {
    const json = qs('#product-json'); if (!json) return;
    const product = JSON.parse(json.textContent);
    const opts = qsa('[data-variant-select]').map(s => s.value);
    const match = product.variants.find(v => opts.every((o, i) => v.options[i] === o));
    if (match) {
      const cmp = match.compare_at_price || 0;
      qs('#variant-id').value = match.id;
      const pw = qs('#price-wrap'); const pb = pw && qs('.price', pw);
      if (pb) pb.innerHTML = priceInner(match.price, cmp, priceCfg(pw));
      const btn = qs('[data-pdp-add]');
      if (btn) {
        btn.disabled = !match.available;
        btn.innerHTML = match.available ? (btn.dataset.labelAdd || 'Add to Cart') + ' · <span id="atc-price">' + money(match.price) + '</span>' : window.theme.strings.soldOut;
        const bn = btn.closest('form') && btn.closest('form').querySelector('button[name="add"]'); if (bn) bn.disabled = !match.available;
      }
      if (match.featured_image) { const main = qs('#galmainimg'); if (main) main.src = match.featured_image.src; }
      if (window.pdpProduct) { window.pdpProduct.variantId = match.id; window.pdpProduct.price = match.price; window.pdpProduct.compare = cmp; window.pdpProduct.available = match.available; renderSticky(); }
      try { const u = new URL(window.location.href); u.searchParams.set('variant', match.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
    }
  }));
  function renderSticky() {
    const sb = qs('#stickybar'); const pp = window.pdpProduct; if (!sb || !pp) return;
    const off = pp.available === false;
    sb.innerHTML = (pp.image ? '<img src="' + pp.image + '" alt="">' : '') +
      '<div class="t">' + pp.title +
      '<div class="price" style="gap:6px"><span class="now" style="font-size:16px">' + money(pp.price) + '</span>' +
      (pp.compare > pp.price ? '<span class="mrp" style="font-size:12px">' + money(pp.compare) + '</span>' : '') + '</div></div>' +
      '<button class="btn p" style="padding:12px 22px" data-sticky-add' + (off ? ' disabled>' + window.theme.strings.soldOut : '>Add to Cart') + '</button>';
  }
  if (window.pdpProduct) {
    const sb = qs('#stickybar');
    renderSticky();
    window.addEventListener('scroll', () => sb.classList.toggle('show', window.scrollY > 560), { passive: true });
    sb.addEventListener('click', (e) => { if (e.target.closest('[data-sticky-add]')) addToCart(window.pdpProduct.variantId, pdpQ, e.target.closest('button')); });
  }
})();
